export const HostTypes = {
  HANDHELD: "handheld",
  STAGING_HANDHELD: "staginghandheld",
  STAGING_WEB: "stagingweb",
  WEB: "web",
};
